class StoriesCarousel extends HTMLElement {
  connectedCallback() {
    this.viewer = this.querySelector('[data-story-viewer]');
    if (!this.viewer) return;

    this.slides = Array.from(this.querySelectorAll('[data-story-slide]'));
    this.bars = Array.from(this.querySelectorAll('[data-story-bar]'));
    this.userEl = this.querySelector('[data-story-user]');
    this.duration = (parseFloat(this.dataset.duration) || 5) * 1000;
    this.index = -1;
    this.timer = null;
    this.currentVideo = null;

    this.querySelectorAll('video').forEach(function (v) {
      v.setAttribute('playsinline', '');
      v.playsInline = true;
    });

    var self = this;
    this.querySelectorAll('[data-story-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.open(parseInt(btn.dataset.index, 10));
      });
    });
    this.querySelectorAll('[data-story-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { self.close(); });
    });

    var next = this.querySelector('[data-story-next]');
    if (next) next.addEventListener('click', function () { self.next(); });
    var prev = this.querySelector('[data-story-prev]');
    if (prev) prev.addEventListener('click', function () { self.prev(); });

    this.onKey = function (e) {
      if (self.viewer.hidden) return;
      if (e.key === 'Escape') self.close();
      else if (e.key === 'ArrowRight') self.next();
      else if (e.key === 'ArrowLeft') self.prev();
    };
    document.addEventListener('keydown', this.onKey);

    var startX = null;
    this.viewer.addEventListener('touchstart', function (e) {
      startX = e.changedTouches[0].clientX;
    }, { passive: true });
    this.viewer.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var d = e.changedTouches[0].clientX - startX;
      if (Math.abs(d) > 50) { d < 0 ? self.next() : self.prev(); }
      startX = null;
    }, { passive: true });
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.onKey);
    this.stop();
  }

  open(i) {
    this.viewer.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    this.show(i);
  }

  close() {
    this.stop();
    this.viewer.hidden = true;
    document.documentElement.style.overflow = '';
    this.slides.forEach(function (s) { s.removeAttribute('data-active'); });
    this.index = -1;
  }

  show(i) {
    if (i < 0) i = 0;
    if (i >= this.slides.length) { this.close(); return; }

    this.stop();
    this.index = i;

    this.slides.forEach(function (s, k) {
      if (k === i) s.setAttribute('data-active', '');
      else s.removeAttribute('data-active');
      var v = s.querySelector('video');
      if (v && k !== i) { v.pause(); v.currentTime = 0; }
    });

    this.bars.forEach(function (bar, k) {
      var fill = bar.firstElementChild;
      fill.style.transition = 'none';
      fill.style.width = k < i ? '100%' : '0%';
    });

    var slide = this.slides[i];
    if (this.userEl) this.userEl.textContent = slide.dataset.name || '';

    var self = this;
    var video = slide.querySelector('video');
    var fill = this.bars[i] ? this.bars[i].firstElementChild : null;

    if (video) {
      this.currentVideo = video;
      video.currentTime = 0;

      this.onTime = function () {
        if (!fill) return;
        var d = video.duration || 0;
        fill.style.transition = 'none';
        fill.style.width = d ? (video.currentTime / d) * 100 + '%' : '0%';
      };
      this.onEnded = function () { self.next(); };
      video.addEventListener('timeupdate', this.onTime);
      video.addEventListener('ended', this.onEnded);

      var p = video.play();
      if (p && p.catch) {
        p.catch(function () {
          video.muted = true;
          video.play().catch(function () {});
        });
      }
    } else if (fill) {
      requestAnimationFrame(function () {
        fill.style.transition = 'width ' + self.duration + 'ms linear';
        fill.style.width = '100%';
      });
      this.timer = setTimeout(function () { self.next(); }, this.duration);
    }
  }

  stop() {
    if (this.timer) { clearTimeout(this.timer); this.timer = null; }
    if (this.currentVideo) {
      this.currentVideo.pause();
      if (this.onTime) this.currentVideo.removeEventListener('timeupdate', this.onTime);
      if (this.onEnded) this.currentVideo.removeEventListener('ended', this.onEnded);
      this.currentVideo = null;
    }
  }

  next() { this.show(this.index + 1); }
  prev() { this.show(this.index - 1); }
}

if (!customElements.get('stories-carousel')) {
  customElements.define('stories-carousel', StoriesCarousel);
}
